import React from 'react';
import MuiSwitch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core';
import { mainColor } from '../../constants';

const Switch = withStyles({
  switchBase: {
    '&$checked ': {
      color: mainColor.secondaryColor
    },
    '&$checked + $track': {
      opacity: 0.5,
      backgroundColor: mainColor.secondaryColor
    }
  },
  track: {
    '&$checked': {
      opacity: 0.5,
      backgroundColor: mainColor.secondaryColor
    }
  },
  disabled: {
    '&$checked + $track': {
      opacity: 0.5,
      backgroundColor: `rgba(0, 0, 0, 0.3) !important`
    },
    color: `rgba(0, 0, 0, 0.3) !important`,
    borderColor: `rgba(0, 0, 0, 0.3) !important`
  },
  checked: {}
})(MuiSwitch);

const SwitchComponent = props => {
  const { disabled, checked, onClick, onChange, inputProps, id, color = 'primary' } = props;
  return (
    <Switch
      checked={checked}
      onClick={onClick}
      onChange={onChange}
      color={color}
      id={id}
      disabled={disabled}
      inputProps={inputProps}
      {...props}
    />
  );
};
export default SwitchComponent;
